import {defaultSettingType} from "../../actions/default-setting/Type";

const initialState = {
    dateFormat: "DD/MM/YYYY",
    language: "vi",
    successCount: 3,
    goBack: true,
    showGoBackModal: true
}

const defaultSettingReducer = (state = initialState, action) => {
    switch (action.type) {
        case defaultSettingType.UPDATE_DEFAULT_SETTING:
            return {
                ...state,
                dateFormat: action.params
            }
        case defaultSettingType.ON_CHANGE_LANGUAGE:
            return {
                ...state,
                language: action.params
            }
        case defaultSettingType.ON_SUCCESS:
            return {
                ...state,
                successCount: state.successCount === 0 ? 3 : state.successCount + action.params
            }
        case defaultSettingType.UPDATE_GO_BACK:
            return {
                ...state,
                goBack: action.params
            }
        case defaultSettingType.UPDATE_SHOW_GO_BACK_MODAL:
            return {
                ...state,
                showGoBackModal: action.params
            }
        case defaultSettingType.RESET:
            return {
                ...initialState
            }
        default:
            return state;
    }
}

export default defaultSettingReducer